export enum NotificationType {
    Success = 0,
    Error = 1,
    General = 2
}

export interface ISignalRNotification {
    message: string;
    type: NotificationType;
    source: string;
    timestamp: string;
    data?: any;
}
